import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { DEFAULT_ASSET_QUERY_LIMIT } from '../../common/constants/AssetQuery/AssetQuery';
const defaults = {
  categories: [],
  hasFreeSupport: null,
  limit: DEFAULT_ASSET_QUERY_LIMIT,
  minReviewCount: null,
  minOverallRating: null,
  offeringIds: [],
  offset: 0,
  planType: null,
  portalCompatible: null,
  priceRange: null,
  providers: [],
  search: null,
  sortFields: [],
  tags: [],
  templateTypes: [],
  tiers: []
};
export class ModuleQuery extends createImmutableObjectClass(defaults) {}